import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=ffa14d88&"
import script from "./BackToTop.vue?vue&type=script&lang=ts&"
export * from "./BackToTop.vue?vue&type=script&lang=ts&"
import style0 from "./BackToTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports